import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import Image from './Image';
export const ImageFullViewWrapper = (props)=>{
    return /*#__PURE__*/ React.createElement(Image, _extends({}, props));
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;
